import { Component, OnInit, Input } from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";

import { Constants } from "../constants/gsfCalc-constants";
import { activityInput } from "../models";

@Component({
  selector: "app-url-field",
  templateUrl: "./url-field.component.html",
  styleUrls: ["./url-field.component.css"]
})
export class UrlFieldComponent implements OnInit {
  @Input() activity: activityInput;
  @Input() isRequired: boolean;
  @Input() activityControl: UntypedFormControl;
  urlPattern = Constants.URL_PATTERN;
  validators =  [Validators.pattern(this.urlPattern)];
  constructor(private readonly translate: TranslateService) {
    translate.setDefaultLang(Constants.LANGUAGE);
  }

  ngOnInit() {
    if (this.activity.ans && this.activity.ans !== "") {
      this.activityControl.setValue(this.activity.ans);
    }
    this.activityControl.setValidators(Validators.min(this.activity.minValue));
    this.activityControl.setValidators(Validators.max(this.activity.maxValue));
    this.activityControl.setValidators(Validators.pattern(Constants.PATTERN));
    if(this.activity.isRequired) {
      this.validators.push(Validators.required)
    }
    this.assignValidators();
    this.onChanges();
  }
  onChanges() {
    this.activityControl.valueChanges.subscribe(value => {
      this.assignValidators();
      this.activity.ans = value;
    });
  }

  assignValidators(){
    this.activityControl.setValidators(this.validators);
  }
}
